import Vue from "vue";
import desktopApp from "./App.desktop.vue";
import desktopRouter from "./route/route.desktop";
// import mobileRouter from "./route/route.mobile";

// import mobileApp from "./App.mobile.vue";
// import { isMobile } from "@/utils";
import "./assets/scss/reset.scss";
import "./icons";
import i18n from "./enums";

Vue.config.productionTip = false;

new Vue({
  i18n,
  router: desktopRouter,
  render: (h) => h(desktopApp),
}).$mount("#app");
